import React, { useState, useEffect } from "react";
import {
  PDFViewer,
  Document,
  Page,
  Text,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";
import axios from "axios";
import { useParams } from "react-router-dom";
import logo from "../../img/logo.png";
import icontec from "../../img/LOGOSeide.png";
import { format } from "date-fns";

const PdfAgenda = () => {
  const { idSolicitud, idEvaluador } = useParams();

  const [data, setData] = useState([]);
  const [institucion, setInstitucion] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerVisitaEvaluadorPorSolicitudIdEvaluadorId?SolicitudId=${idSolicitud}&EvaluadorId=${idEvaluador}`,
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchInstitucion = async () => {
      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerQSolicitudesPorEvaluador?EvaluadorId=${idEvaluador}`,
        );
        if (response.data.length > 0) {
          setInstitucion(
            response.data[response.data.length - 1].nombreInstitucion,
          );
        }
      } catch (error) {
        console.error("Error fetching institution name:", error);
      }
    };

    fetchData();
    fetchInstitucion();
  }, [idSolicitud, idEvaluador]);

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 15,
    },
    table: {
      width: "100%",
      borderWidth: 1,
      borderColor: "#000",
      borderStyle: "solid",
      marginVertical: 10,
    },
    tableRow: {
      flexDirection: "row",
      width: "100%",
    },
    headerRow: {
      backgroundColor: "#f2f2f2",
    },
    headerCell: {
      fontSize: 12,
      fontWeight: "bold",
      textAlign: "center",
      padding: 8,
      flex: 1,
      borderWidth: 1,
      borderColor: "#000",
      borderStyle: "solid",
    },
    textHeader: {
      fontSize: 14,
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      paddingRight: 10,
    },
    image: {
      width: 60,
      height: 90,
    },
    imageIcon: {
      width: 90,
      height: 100,
    },
    tableCell: {
      fontSize: 10,
      textAlign: "center",
      padding: 8,
      flex: 1,
      borderWidth: 1,
      borderColor: "#000",
      borderStyle: "solid",
    },
    tableCellHeader: {
      fontSize: 10,
      textAlign: "center",
      padding: 8,
      flex: 1,
      borderColor: "#000",
      borderStyle: "solid",
    },
  });

  return (
    <PDFViewer width={"100%"} height="1000">
      <Document>
        <Page style={styles.body}>
          <View style={styles.tableRow}>
            <View style={styles.tableCellHeader}>
              <Image style={styles.image} src={logo} />
            </View>

            <View style={{ width: "60%", textAlign: "center" }}>
              <Text>{"\n"}</Text>
              <Text style={styles.textHeader}>
                AGENDA DE REUNIONES EVALUACIÓN DE ACREDITACIÓN EN SALUD
              </Text>
              <Text>{"\n"}</Text> {/* This line adds an empty space */}
              <Text style={styles.textHeader}>{institucion}</Text>
            </View>
            <View style={styles.tableCellHeader}>
              <Image style={styles.imageIcon} src={icontec} />
            </View>
          </View>

          <View style={styles.table}>
            <View style={[styles.tableRow, styles.headerRow]}>
              <Text style={styles.headerCell}>Fecha Inicial</Text>
              <Text style={styles.headerCell}>Fecha Final</Text>
              <Text style={styles.headerCell}>Objetivo</Text>
              <Text style={styles.headerCell}>Actividad</Text>
              <Text style={styles.headerCell}>Observaciones</Text>
            </View>

            {data.map((item, index) => {
              const fechaFormateada = format(
                new Date(item.fechaInicial),
                "dd/MM/yyyy HH:mm:ss",
              );
              const fechaFormateadaFinal = format(
                new Date(item.fechaFinal),
                "dd/MM/yyyy HH:mm:ss",
              );
              return (
                <View key={index} style={styles.tableRow}>
                  <Text style={styles.tableCell}>{fechaFormateada}</Text>
                  <Text style={styles.tableCell}>{fechaFormateadaFinal}</Text>
                  <Text style={styles.tableCell}>{item.objetivo}</Text>
                  <Text style={styles.tableCell}>{item.actividad}</Text>
                  <Text style={styles.tableCell}>{item.observaciones}</Text>
                </View>
              );
            })}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default PdfAgenda;
